import { setOnerror } from '@ember/-internals/error-handling';
import { didCancel } from 'ember-concurrency';

export function initialize(appInstance) {
  setOnerror(function (error) {
    const errorsHandledByAdapter = ['400', '401', '403', '404'];
    // Ignore ember concurrency task cancellation errors as they shouldn't result in showing an alert to the user
    if (
      error &&
      error.name !== 'TransitionAborted' &&
      error.name !== 'SilentTaskError' &&
      !errorsHandledByAdapter.includes(error.errors?.[0]?.status) &&
      !didCancel(error)
    ) {
      try {
        const errorTracking = appInstance.lookup('service:error-tracking');
        errorTracking.captureException(error);
      } catch {
        // ignore
      }

      const alerting = appInstance.lookup('service:alerting');

      // Show error message and redirect to homepage
      alerting
        .showErrorAlert({
          title: 'Oops, something went wrong',
          text: 'Something went wrong. Please try again in a couple of minutes. Please contact Customer Care via the chat box in the bottom right of the screen if the error persists.',
          buttons: {
            cancel: false,
          },
        })
        .then(() => {
          // Note for TA iframe integration case:
          // In case of a general error, we will try and reset the location of the app (so not reloading the parent page, which we do for 4xx errors)
          window.location.href = '/';
        });
    }
  });
}

export default {
  name: 'error',
  initialize,
};
